import { gql } from '@apollo/client';

export const INSIGHT_SUB_RESOLUTION_FRAGMENT = gql`
  fragment InsightSubResolutionFragment on InsightResolution {
    id
    name
    description
    parentId
  }
`;

export const INSIGHT_RESOLUTION_FRAGMENT = gql`
  fragment InsightResolutionFragment on InsightResolution {
    id
    name
    description
    parentId
    subResolutions {
      ...InsightSubResolutionFragment
    }
  }
  ${INSIGHT_SUB_RESOLUTION_FRAGMENT}
`;

export const INSIGHT_RESOLUTIONS_QUERY = gql`
  query InsightResolutionQueryOperation {
    insightResolutions(sourceFilter: "sumo") {
      total
      objects {
        ...InsightResolutionFragment
      }
    }
  }
  ${INSIGHT_RESOLUTION_FRAGMENT}
`;

export const DELETE_RESOLUTION_MUTATION = gql`
  mutation DeleteInsightResolutionOperation($id: Int!) {
    deleteInsightResolution(id: $id) {
      ok
    }
  }
`;

export const CREATE_INSIGHT_RESOLUTION_MUTATION = gql`
  mutation CreateInsightResolutionMutationOperation(
    $fields: CreateInsightResolutionFields!
  ) {
    createInsightResolution(fields: $fields) {
      data {
        ...InsightSubResolutionFragment
      }
    }
  }
  ${INSIGHT_SUB_RESOLUTION_FRAGMENT}
`;

export const UPDATE_INSIGHT_RESOLUTION_MUTATION = gql`
  mutation UpdateInsightResolutionMutationOperation(
    $fields: UpdateInsightResolutionFields!
    $id: Int!
  ) {
    updateInsightResolution(fields: $fields, id: $id) {
      data {
        ...InsightSubResolutionFragment
      }
    }
  }
  ${INSIGHT_SUB_RESOLUTION_FRAGMENT}
`;

export const INSIGHT_RESOLUTION_QUERY = gql`
  query SingleInsightResolutionQueryOperation($id: Int!) {
    insightResolution(id: $id) {
      ...InsightResolutionFragment
    }
  }
  ${INSIGHT_RESOLUTION_FRAGMENT}
`;
